import { j as t } from "../../../jsx-runtime-B6kdoens.js";
import { useRef as i } from "react";
import { createPortal as f } from "react-dom";
import { a as c } from "../../../index-CROKJrb5.js";
import { c as u, f as n } from "../../../create-component-CBAeEoQ6.js";
import { u as p } from "../../../use-merge-refs-DEJnLwh4.js";
import { ToastRenderer as l } from "../ToastRenderer/index.js";
import { useToastStateAtoms as x } from "../ToastState/index.js";
import { u as d } from "../../../react-B_GApDuV.js";
const v = u(
  "ToastList",
  n(({ className: o }, r) => {
    const { toastsAtom: s } = x(), e = d(s), a = i(null), m = p(r, a);
    return typeof window != "object" ? null : f(
      /* @__PURE__ */ t.jsx(
        "div",
        {
          className: c(
            "cur-fixed cur-right-2 cur-top-2 cur-z-[1000] cur-flex cur-flex-col cur-gap-2",
            o
          ),
          ref: m,
          "aria-live": "polite",
          children: /* @__PURE__ */ t.jsx(l, { toasts: e })
        }
      ),
      document.body
    );
  })
);
export {
  v as ToastList
};
//# sourceMappingURL=index.js.map
